module.exports = __webpack_public_path__ + "static/media/faq-balance-video-answer.6b8c3ea4.svg";